import { render, staticRenderFns } from "./BudgetLimits.vue?vue&type=template&id=3de9ff5d&scoped=true&"
import script from "./BudgetLimits.vue?vue&type=script&lang=js&"
export * from "./BudgetLimits.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLimits.vue?vue&type=style&index=0&id=3de9ff5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9ff5d",
  null
  
)

export default component.exports